import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { currencies } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['6 tomos principales', '15 días de protocolo', "50 recetas antiinflamatorias", 'Los 6 bonos estratégicos'];
const valueRows = [{
  label: '6 tomos principales',
  value: "USD 25.80"
}, {
  label: '6 bonos complementarios',
  value: "USD 51.00"
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-white py-20 sm:py-28 space-y-[12px]" aria-labelledby="oferta-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-140" data-mp="2add7fzjbrc0t">
      <div className="mx-auto max-w-5xl px-6" data-id="element-141" data-mp="pjz3tw1afjzb">
        {showUrgency ? <Reveal data-id="element-142" data-mp="uiimnnkl4fng">
            <div className="rounded-3xl bg-mint-50 px-6 py-10 sm:px-12" data-id="element-143" data-mp="ui0o2kag9pcd">
              <CountdownTimer label="COMPRANDO DENTRO DE LAS PRÓXIMAS 24 HORAS" note="Después sube el precio y no vuelve a bajar." data-id="element-144" data-mp="zi54kabcyk2l" />
              
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-145" data-mp="6u97v5lsgs5t">
          <div className="text-center" data-id="element-146" data-mp="6rmqyfd0d0ax">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-147" data-mp="bsashuyv4zje">
              Elegí tu MegaPack
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-148" data-mp="fskuyxng57ti">
              Todas las opciones incluyen los 6 bonos estratégicos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-149" data-mp="3k845hztzjsvp">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-mint-300 bg-white shadow-lift" data-id="element-150" data-mp="3oa7l90notjms">
            <p className="bg-mint-600 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-151" data-mp="vf7b8aa8w48w">
              Pack completo · el más elegido
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-152" data-mp="155agp9yjzao4">
              <div data-id="element-153" data-mp="106pex63nkixk">
                <h3 className="font-display text-3xl text-ink" data-id="element-154" data-mp="10678xhr6uqcg">Pack Completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-155" data-mp="cgmosvjatn1l">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-156" data-mp="ciz759syxzf6">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-157" data-mp="7jcryutky93q" />
                      <span className="text-[15px] text-ink-soft" data-id="element-158" data-mp="lj4bfb2v8hp4">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-mint-100 pt-6 text-sm" data-id="element-159" data-mp="hic3cl5qciuf">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-160" data-mp="1sv4sdo74yt6s">
                      <dt className="text-ink-muted" data-id="element-161" data-mp="1sx7h84wjyg9x">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-162" data-mp="20dujfzm2y1ha">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-163" data-mp="25erwxyw5a7cg">
                    <dt data-id="element-164" data-mp="1qh9efea28qdg">Valor total real</dt>
                    <dd data-id="element-165" data-mp="1qikh1arrrs2z">USD 76.80</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-166" data-mp="1vhnb6067odw6">
                <p className="text-sm text-ink-muted line-through" data-id="element-167" data-mp="2j4vfaerwlgwm">USD 76.80</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-168" data-mp="2o3yn26z9q18a">
                  USD 19.99
                </p>
                <p className="mt-4 inline-flex w-fit rounded-full bg-mint-100 px-3 py-1.5 text-sm font-semibold text-mint-800" data-id="element-169" data-mp="2eef3ez3qe3cd">
                  Ahorrás USD 62.81 · 75% off
                </p>

                <div className="mt-8" data-id="element-170" data-mp="3226ha74x6ofr">
                  <CtaButton className="w-full" data-id="element-171" data-mp="36uzmew4avysd">Quiero el Megapack</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-172" data-mp="1j7fsez7ulxjp">
                  El precio está expresado en dólares estadounidenses (USD). No te preocupes, el cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-173" data-mp="14bhxtldkp19l">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-174" data-mp="21x5lnhvyqb9i">
            <p className="text-center text-sm font-medium text-ink" data-id="element-175" data-mp="21yysoyahmxi1">
              Pagás en tu moneda local
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-176" data-mp="1s72rvfh0ota4">
              {currencies.map(currency => <li key={currency} className="whitespace-nowrap rounded-full bg-mint-50 px-3 py-1.5 text-xs text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-177" data-mp="1n7zsaajt3f9j">
                  {currency}
                </li>)}
            </ul>

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-178" data-mp="2fwf0oe8fmzbw">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-179" data-mp="2o62u05p6gwj4">
                  <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-180" data-mp="2s7epgruqgbz8" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}